import { NgIf } from '@angular/common';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { WebSocketService } from '../../../../services/websocket.service';
import { decode } from 'base64-arraybuffer';
import { AiAgentResponse } from '../../../../models/responses/ai-agent-response';


@Component({
  selector: 'app-test-assistant',
  standalone: true,
  imports: [NgIf, MatButtonModule],
  templateUrl: './test-assistant.component.html',
  styleUrl: './test-assistant.component.scss'
})
export class TestAssistantComponent {
  @Input() aiAgent!: AiAgentResponse;
  private mediaRecorder: MediaRecorder | null = null;
  private timeslice = 30;// Indicates the time when audio data can be pushed. Here its pushes every 30 ms
  private options = { mimeType: 'audio/webm;codecs=opus' };// forces opus encoding
  private audioRecorderOptions = { noiseSuppression: true, echoCancellation: true, sampleRate: 48000, channelCount: 1 };
  private stream!: MediaStream;
  private audioArrayBuffers: ArrayBuffer[] = []
  private dummyValue = "DUMMY";
  private audioContext: AudioContext;
  private source!: AudioBufferSourceNode;
  private NAVIGATOR_SETUP_TIMEOUT = 2000;
  testInProcess: boolean = false;

  constructor(private websocketService: WebSocketService) {
    this.audioContext = new AudioContext();
    this.websocketService.audioDataEmitter.subscribe(data => this.handleAIAgentAudioEmitted(data));
  }

  startRecording() {
    this.testInProcess = true;
    if (this.aiAgent) {
      this.websocketService.open();
      this.websocketService.sendStartEvent(this.dummyValue, this.dummyValue, 'en', this.aiAgent.id); // TODO let user select his language
      //set timeout of two seconds here
      setTimeout(() =>
        navigator.mediaDevices.getUserMedia({ audio: this.audioRecorderOptions })
          .then(stream => this.handleAudioStream(stream))
          .catch(error => {
            console.error('Error accessing microphone', error);
          }), this.NAVIGATOR_SETUP_TIMEOUT); // we have to set a 2 second timeout before sending audio or else backend don't transcribe
    } else {
      alert("UI error, contact support");
    }
  }

  stopRecording() {
    if (this.mediaRecorder) {
      this.websocketService.sendStopEvent("");
      this.testInProcess = false;
      this.stream.getTracks().forEach(track => track.stop());
      this.mediaRecorder.stop();
      this.websocketService.close();
      this.interuptAudio();
    }
  }
  private interuptAudio() {
    this.source.stop(0);  // Stop the currently playing audio
    this.audioArrayBuffers = []
  }

  private handleAudioStream(stream: MediaStream) {
    this.stream = stream;
    this.mediaRecorder = new MediaRecorder(stream, this.options);
    this.mediaRecorder.start(this.timeslice);

    this.mediaRecorder.addEventListener('dataavailable', this.handleDataAvailable.bind(this));

    this.mediaRecorder.addEventListener('stop', () => {
      console.log("audio recording stopped");
    });
  }

  private processNextAudio() {
    const arrayBuffer = this.audioArrayBuffers[0];
    if (arrayBuffer) {
      this.playAudio(arrayBuffer);
    }else{
      this.websocketService.sendMarkEvent("")
    }
  }

  private handleAIAgentAudioEmitted(data: any) {
    if (data.media && data.media.payload) {
      const arrayBuffer = decode(data.media.payload);
      this.audioArrayBuffers.push(arrayBuffer);
      if (this.audioArrayBuffers.length == 1) {
        this.processNextAudio();
      }
    } else if (data.event == "clear") {
      this.interuptAudio();
    }
  }


  private async playAudio(audioData: ArrayBuffer): Promise<void> {
    const audioBuffer = await this.audioContext.decodeAudioData(audioData);
    this.source = this.audioContext.createBufferSource();
    this.source.buffer = audioBuffer;
    this.source.connect(this.audioContext.destination);
    this.source.start(0);
    this.source.onended = () => {
      this.audioArrayBuffers.shift();
      this.processNextAudio();
    }
  }

  private handleDataAvailable(event: BlobEvent) {
    const reader = new FileReader();
    reader.onload = () => {
      const arrayBuffer = reader.result as ArrayBuffer;
      const base64String = btoa(String.fromCharCode(...new Uint8Array(arrayBuffer)));
      this.websocketService.sendMediaEvent(this.dummyValue, base64String);
    };
    reader.readAsArrayBuffer(event.data);
  }

}
